import Vue from 'vue'
import router from './router';
import './styles/tailwind.css' // 先引入 Tailwind CSS
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import store from './store'

// 全局注册
import LoginModalPlugin from '@/plugins/loginModal'
// Vue.use(LoginModalPlugin)
Vue.use(LoginModalPlugin, { store, router })

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
